import { render, staticRenderFns } from "./DashboardTrendbox.vue?vue&type=template&id=bc1c121c&scoped=true"
import script from "./DashboardTrendbox.vue?vue&type=script&lang=js"
export * from "./DashboardTrendbox.vue?vue&type=script&lang=js"
import style0 from "./DashboardTrendbox.vue?vue&type=style&index=0&id=bc1c121c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1c121c",
  null
  
)

export default component.exports